export type DepenseCategorie =
  | "reparation"
  | "electricite"
  | "eau"
  | "nettoyage"
  | "securite"
  | "entretien"
  | "taxe"
  | "assurance"
  | "autre";

export interface Depense {
  id: string;
  libelle: string;
  categorie: DepenseCategorie;
  montant: number;
  date: string;
  immeubleId: string;
  bienId: string;
  description: string;
  justificatif: string;
  createdAt: string;
}

export type DepenseInput = Omit<Depense, "id" | "createdAt">;

export const DEPENSE_CATEGORIE_LABELS: Record<DepenseCategorie, string> = {
  reparation: "Réparation",
  electricite: "Électricité",
  eau: "Eau",
  nettoyage: "Nettoyage",
  securite: "Sécurité",
  entretien: "Entretien",
  taxe: "Taxe",
  assurance: "Assurance",
  autre: "Autre",
};

export const DEPENSE_CATEGORIE_ICONS: Record<DepenseCategorie, string> = {
  reparation: "ri-tools-line",
  electricite: "ri-flashlight-line",
  eau: "ri-water-flash-line",
  nettoyage: "ri-brush-line",
  securite: "ri-shield-check-line",
  entretien: "ri-hammer-line",
  taxe: "ri-government-line",
  assurance: "ri-shield-star-line",
  autre: "ri-more-line",
};

export const DEPENSE_CATEGORIE_TONES: Record<
  DepenseCategorie,
  "primary" | "accent" | "secondary" | "neutral"
> = {
  reparation: "accent",
  electricite: "secondary",
  eau: "primary",
  nettoyage: "neutral",
  securite: "secondary",
  entretien: "accent",
  taxe: "primary",
  assurance: "neutral",
  autre: "neutral",
};

export const DEPENSE_CATEGORIE_OPTIONS = (Object.keys(DEPENSE_CATEGORIE_LABELS) as DepenseCategorie[]).map(
  (value) => ({
    value,
    label: DEPENSE_CATEGORIE_LABELS[value],
  })
);

/**
 * Modèle de données prévu pour Supabase.
 * Table cible : `depenses`
 *   id uuid primary key default gen_random_uuid()
 *   owner_id uuid references auth.users(id)
 *   immeuble_id uuid references immeubles(id) on delete set null
 *   bien_id uuid references biens(id) on delete set null
 *   categorie text not null, montant numeric not null
 *   date date not null, description text, justificatif_url text
 *   created_at timestamptz default now()
 */